import { useLoading } from '../../hooks/LoadingContext'
import styles from './LoadingSpinner.module.css'
import { Spinner } from 'react-bootstrap'

const LoadingSpinner = ({ text }) => {
  const { isLoading } = useLoading()

  return (
    <>
      {isLoading ? (
        <div className={styles.loadingContainer}>
          <Spinner variant="secondary" />
          <h4 className="mt-2 text-muted text-center w-75">{text || 'Carregando informações'}</h4>
        </div>
      ) : (
        <></>
      )}
    </>
  )
}

export default LoadingSpinner
